var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import to from 'await-to-js';
import * as Utils from '../common/Utils';
export * from './Types';
export const URLPATH = '/.sportsbet/program/matches?';
export function getMatches(host, params) {
    return __awaiter(this, void 0, void 0, function* () {
        if (params.matchCount == '0')
            return to(Promise.resolve([]));
        return to(fetch(`${host}${URLPATH}${Utils.paramsToQuery(params)}`).then((response) => __awaiter(this, void 0, void 0, function* () {
            if (!response.ok) {
                throw new Error(yield response.text());
            }
            return response.json();
        })));
    });
}
export function getMatchesURL(host, params) {
    return `${host}${URLPATH}${Utils.paramsToQuery(params)}`;
}
export function encodeSelectionParams(host, params) {
    return __awaiter(this, void 0, void 0, function* () {
        return to(fetch(`${host}/.sportsbet/program/encodeSelection?${Utils.paramsToQuery(params)}`).then((response) => __awaiter(this, void 0, void 0, function* () {
            if (!response.ok) {
                throw new Error(yield response.text());
            }
            return response.json();
        })));
    });
}
//# sourceMappingURL=index.js.map